__turbopack_context__.v({
  "copyright": "Copyright-module-scss-module__qa7oTq__copyright",
});
